module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "intro"
    }
  }, [_c('span', {
    staticClass: "epub-scb"
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("There are no new jokes, practically! All, almost, are variations on existing themes. Where are these variations germinated? Where are the few new themes conceived?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("On Wall Street, we have all been led to believe. These sick jokes are mainly disseminated on the floors of the exchanges, then spread across the nation like wildfire, via telephone, fax, and now E-mail.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Why Wall Street? Who knows, but the electrified atmosphere in the money canyons, inhabited by a rare breed of humorous and ebullient souls, seems to have yielded an endless harvest of humor for many, many years.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Herein is a sampling.")]), _vm._v(" "), _c('p', {
    staticClass: "stx"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("—F"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("OUR")]), _vm._v(" A"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NONYMOUS")]), _vm._v(" W"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ALL")]), _vm._v(" S"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TREET")]), _vm._v(" G"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("UYS")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdc9052c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/intro.vue
// module id = 69
// module chunks = 0